import { SisternodeOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { get } from 'lodash';
import { Datatype } from '../../../../expressions/datatype/Datatype';
import {
  IReference,
  ReferenceType,
} from '../../../../expressions/references/IReference';
import { IReferencePath } from '../../../../expressions/references/IReferencePath';
import { tran } from '../../../../translations/schema/TranslationSchema';
import { IWidgetType } from '../../../IWidgetType';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget';
import { createCommonFormSchema } from '../../inputs/common/createCommonFormSchema';
import { ISwitchWidget } from './ISwitchWidget';
import { ScoreWidgetPreviewComponent } from './ScoreWidgetPreviewComponent';
import { SwitchWidgetComponent } from './SwitchWidgetComponent';
import { SwitchWidgetConfigComponent } from './SwitchWidgetConfigComponent';
import { SwitchWidgetConfigSchema } from './SwitchWidgetConfigSchema';
import { createSwitchWidgetSchema } from './createSwitchWidgetSchema';

export const SwitchWidgetType: IWidgetType<ISwitchWidget> = {
  type: WidgetType.Switch,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Computed,
  name: 'Valore condizionale',
  icon: <SisternodeOutlined aria-hidden />,
  hasValue: true,
  getReference: (path: IReferencePath, widget: ISwitchWidget): IReference => ({
    type: ReferenceType.Widget,
    widgetType: widget.type,
    path,
    id: widget.id,
    code: widget.code,
    label: widget.code,
    field: {
      type: widget.datatype,
    },
  }),
  formComponent: SwitchWidgetComponent,

  createFormSchema: input => {
    return createCommonFormSchema(
      createSwitchWidgetSchema(input),
      input.widget,
    );
  },
  previewComponent: ScoreWidgetPreviewComponent,
  configComponent: SwitchWidgetConfigComponent,
  configValidator: SwitchWidgetConfigSchema,
  rules: [],
  translationSchema: tran.widget({
    label: tran.rte(),
    helpText: tran.rte(),
    placeholder: tran.string(),
    rules: tran.rules(),
  }),
  dynamicReference: true,
  alwaysEnabled: true,
  hydrate: ({ context, widget, path }) => {
    const value = get(context.values, path);
    if (!value) return { value };

    if (widget.datatype === Datatype.Date) {
      return {
        value: dayjs(value, [
          'YYYY-MM-DD',
          'DD/MM/YYYY',
          'YYYY-MM-DDTHH:mm:ss',
          'YYYY-MM-DDTHH:mm:ss.SSS',
          'YYYY-MM-DDTHH:mm:ss.SSSZ',
          'YYYY-MM-DDTHH:mm:ssZ',
          'YYYY-MM-DDTHH:mm:ss.SSSSSS',
          'DD-MM-YYYY',
        ]).format('DD/MM/YYYY'),
      };
    }

    return {
      value,
    };
  },
};
